import React from 'react';
import { CheckCircle } from 'lucide-react';
import { aboutContent } from '../data/mock';
import { useTheme } from '../context/ThemeContext';

const AboutSection = () => {
  const { theme } = useTheme();

  return (
    <section id="about" className={`relative py-16 sm:py-20 lg:py-24 transition-colors duration-300 ${
      theme === 'dark' ? 'bg-[#0a0a0a]' : 'bg-white'
    }`}>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-[7.6923%]">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Left Column */}
          <div>
            <div className={`inline-flex items-center gap-2 px-3 sm:px-4 py-2 mb-4 sm:mb-6 border ${
              theme === 'dark' ? 'border-white/20 bg-white/5' : 'border-gray-200 bg-gray-50'
            }`}>
              <span className={`text-xs sm:text-sm font-medium tracking-wide uppercase ${
                theme === 'dark' ? 'text-white/70' : 'text-gray-600'
              }`}>About Us</span>
            </div>
            
            <h2 className={`text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight mb-4 sm:mb-6 ${
              theme === 'dark' ? 'text-white' : 'text-gray-900'
            }`}>
              {aboutContent.title}
            </h2>
            
            <p className={`text-base sm:text-lg leading-relaxed mb-6 sm:mb-8 ${
              theme === 'dark' ? 'text-white/70' : 'text-gray-600'
            }`}>
              {aboutContent.description}
            </p>

            {/* Highlights */}
            <div className="space-y-3 sm:space-y-4">
              {aboutContent.highlights.map((highlight, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle className={`w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0 mt-0.5 ${
                    theme === 'dark' ? 'text-[#00FFD1]' : 'text-[#00997A]'
                  }`} />
                  <span className={`text-sm sm:text-base ${
                    theme === 'dark' ? 'text-white/80' : 'text-gray-700'
                  }`}>
                    {highlight}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Stats */}
          <div className="grid grid-cols-2 gap-3 sm:gap-4">
            <div className={`p-4 sm:p-6 lg:p-8 text-center ${
              theme === 'dark' ? 'bg-black border border-white/10' : 'bg-gray-50 border border-gray-200'
            }`}>
              <p className={`text-3xl sm:text-4xl lg:text-5xl font-bold mb-1 sm:mb-2 ${
                theme === 'dark' ? 'text-[#00FFD1]' : 'text-[#00997A]'
              }`}>500+</p>
              <p className={`text-xs sm:text-sm ${theme === 'dark' ? 'text-white/50' : 'text-gray-500'}`}>
                IT Professional Network
              </p>
            </div>
            <div className={`p-4 sm:p-6 lg:p-8 text-center ${
              theme === 'dark' ? 'bg-black border border-white/10' : 'bg-gray-50 border border-gray-200'
            }`}>
              <p className={`text-3xl sm:text-4xl lg:text-5xl font-bold mb-1 sm:mb-2 ${
                theme === 'dark' ? 'text-[#00FFD1]' : 'text-[#00997A]'
              }`}>98%</p>
              <p className={`text-xs sm:text-sm ${theme === 'dark' ? 'text-white/50' : 'text-gray-500'}`}>
                Client Satisfaction
              </p>
            </div>
            <div className={`p-4 sm:p-6 lg:p-8 text-center ${
              theme === 'dark' ? 'bg-black border border-white/10' : 'bg-gray-50 border border-gray-200'
            }`}>
              <p className={`text-3xl sm:text-4xl lg:text-5xl font-bold mb-1 sm:mb-2 ${
                theme === 'dark' ? 'text-[#00FFD1]' : 'text-[#00997A]'
              }`}>48h</p>
              <p className={`text-xs sm:text-sm ${theme === 'dark' ? 'text-white/50' : 'text-gray-500'}`}>
                Avg Response Time
              </p>
            </div>
            <div className={`p-4 sm:p-6 lg:p-8 text-center ${
              theme === 'dark' ? 'bg-black border border-white/10' : 'bg-gray-50 border border-gray-200'
            }`}>
              <p className={`text-3xl sm:text-4xl lg:text-5xl font-bold mb-1 sm:mb-2 ${
                theme === 'dark' ? 'text-[#00FFD1]' : 'text-[#00997A]'
              }`}>50+</p>
              <p className={`text-xs sm:text-sm ${theme === 'dark' ? 'text-white/50' : 'text-gray-500'}`}>
                Enterprise Clients
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
